

import { createContext } from "react";
import { Article } from "../../constants";

export const FavoriteArticleContext = createContext<ContextProps>({
    isMenuOpen: false,
    setIsMenuOpen: () => { },
    fontSize: 62.5,
    setFontSize: () => { },
    article: null,
    toggleMenu: () => { },
    isLoading: true,
    error: null,
    onBack: () => { }
})


interface ContextProps {
    isMenuOpen: boolean;
    setIsMenuOpen: (isOpen: boolean) => void;
    fontSize: number;
    setFontSize: (size: number) => void;
    article: Article | null;
    toggleMenu: Function;
    isLoading: boolean;
    error?: Error | null;
    onBack: () => void
}